(function () {
    'use strict';

    angular.module('caffeprint')
        .directive('cpSrc', cpSrc);

    cpSrc.$inject = ['$http', '$window'];

    function cpSrc($http, $window) {
        return {
            restrict: 'A',
            scope: {},
            link: function (scope, element, attrs) {
                var URL = $window.URL || $window.webkitURL;

                scope.$watch('objectURL', function (objectURL) {
                    element.attr('src', objectURL);
                });

                scope.$on('$destroy', function () {
                    revokeObjectURL();
                });

                attrs.$observe('cpSrc', function (url) {
                    revokeObjectURL();

                    if (url && url.indexOf('data:') === 0) {
                        $scope.objectURL = url;
                    } else if (url) {
                        $http.get(url, {
                            responseType: 'arraybuffer',
                            headers: {
                                'accept': 'image/webp,image/*,*/*;q=0.8'
                            }
                        }).then(function (response) {
                            var blob = new Blob(
                                [response.data],
                                {type: response.headers('Content-Type')}
                            );
                            scope.objectURL = URL.createObjectURL(blob);
                        });
                    }
                });

                function revokeObjectURL() {
                    if (scope.objectURL) {
                        URL.revokeObjectURL(scope.objectURL);
                    }
                }
            }
        }
    }
})();
